export interface IAuthData {
  id?: string;
  role?: string;
  role_name?: string;
  role_type?: string;
}

export class AuthData {
  id?: string;
  role?: string;
  role_name?: string;
  role_type?: string;

  constructor( data: IAuthData = {} ) {
    this.id = data.id;
    this.role = data.role;
    this.role_name = data.role_name;
    this.role_type = data.role_type;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/auth/auth-data.ts